module.exports = __webpack_public_path__ + "img/column_202308.73ebf8f0.jpg";